<template>
  <div class="p2p-2r-row">

    <div class="p2p-left-col">

      <div class="p2p-routec">
        <img
          class="img-bus"
          src="../../../assets/bus.png"
        />
        {{ p2pResult.route1 }}
        <div
          v-if="p2pResult.service_mode1 === 'T'"
          class="special-route"
        >
          <md-icon>priority_high</md-icon>
        </div>
      </div>
      <div class="p2p-routec">
        <img
          class="img-bus"
          src="../../../assets/bus.png"
        />
        {{ p2pResult.route2 }}
        <div
          v-if="p2pResult.service_mode2 === 'T'"
          class="special-route"
        >
          <md-icon>priority_high</md-icon>
        </div>
      </div>

    </div>

    <div class="p2p-right-col">
      <div class="fare">
        $ {{ p2pResult.total_fare }}
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: "PointToPoint2R",
  props: ['p2pResult'],

}
</script>

<style scoped>
.p2p-routec {
  display: inline-block;
  width: 98px;
  margin-right: 8px;
}

.p2p-2r-row {
  display: flex;
}

.p2p-left-col {
  flex: 1 0 140px;
}

.p2p-right-col {
  flex: 0 0 80px;
}

.img-bus {
  width: 24px;
  height: 24px;
}

.special-route {
  display: inline-block;
}
</style>
